import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { preferenceActions } from '../../../actions';
import useDispatch from '../../../hooks/useDispatch';
import { usePreferences } from '../../../hooks/usePreferences';
import {
  DL_SWITCH_CLASS_NAME,
  DL_SWITCH_LEAD_CLASS_NAME,
} from '../PriceViewer';

const FearGreedSwitch: React.FC<{
  wrapAnalytics: (dataKey: string, callback: () => void) => () => void;
}> = ({ wrapAnalytics }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { showFearGreedIndex } = usePreferences();
  return (
    <>
      <div
        className={classNames(DL_SWITCH_LEAD_CLASS_NAME, DL_SWITCH_CLASS_NAME, {
          checked: showFearGreedIndex,
        })}
        onClick={wrapAnalytics('bb', () => {
          dispatch(
            preferenceActions.setPriceViewerFearGreedIndex(!showFearGreedIndex)
          );
        })}
      >
        {t('fear-greed-index')}
      </div>
    </>
  );
};

export default FearGreedSwitch;
